import { useState, useEffect } from "react"
import Button from 'react-bootstrap/Button'
import Warning from "../../../components/Warning";
import BasicCard from "../../../components/basics/cards/BasicCard";
import { ScenarioAPIService } from "../../../services/apis/ScenarioAPIService";
import { CommonAPIService } from "../../../services/apis/CommonAPIService";
import './LocalScenarioAddEdit.css'
import AlertMessage from "../../../components/AlertMessage";

export default function LocalScenarioAddEdit({ scenarioSelection, setScenarioSelection, setShowAddEdit, state, setState, selectedScenario, filterArray }) {
    const [cancelWarning, setCancelWarning] = useState(false);
    const [currencies, setCurrencies] = useState([]);
    const [mappingTypes, setMappingTypes] = useState([]);
    const [alertObject, setAlertObject] = useState({ variant: '', alertMessage: '' });

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        const scenario = state.scenario;
        scenario[name] = value;
        setState(values => ({ ...values, scenario: scenario }))
    }

    const handleCheck = (e) => {
        const name = e.target.name;
        const value = e.target.checked;
        const scenario = state.scenario;
        scenario[name] = value;
        setState(values => ({ ...values, scenario: scenario }))
    }

    // EVENT HANDLERS
    const handleCancel = () => {
        setCancelWarning(true)
    }

    useEffect(() => {
        CommonAPIService.getMappingTypes()
            .then(data => setMappingTypes(data))

        ScenarioAPIService.getCurrencyBuckets()
            .then(data => setCurrencies(data))
    }, [])

    const refreshScenarioList = () => {
        const selectedNodeId = filterArray ? filterArray[1].value : 0
        ScenarioAPIService.searchScenarios(selectedNodeId)
            .then(data => {                

                if (data.error) {
                    setAlertObject({ variant: 'danger', alertMessage: 'An error occured while loading scenario' });
                }
                else {
                    setScenarioSelection(data);                    
                }
            })
    }


    const handleSave = (e) => {
        e.preventDefault();
        setAlertObject({ variant: '', alertMessage: '' });
        if (state.scenario.scenarioName === undefined || state.scenario.scenarioName === '') {
            setAlertObject({ variant: 'danger', alertMessage: 'Scenario name should not be empty.' })
            return false;
        }

        if (state.scenario.mappingTypeId === "" || state.scenario.mappingTypeId === undefined) {
            setAlertObject({ variant: 'danger', alertMessage: 'Mapping type must be supplied.' })
            return false;
        }

        if (state.scenario.tagetikCurrencyBucket === "" || state.scenario.tagetikCurrencyBucket === undefined) {
            setAlertObject({ variant: 'danger', alertMessage: 'Tagetik currency bucket must be supplied.' })
            return false;
        }

        var newItem = {
            scenarioCode: state.scenario.scenarioCode ?? "",
            scenarioName: state.scenario.scenarioName,
            scenarioTypeId: 2,  // LOCAL scenario type ID
            mappingTypeId: state.scenario.mappingTypeId,
            memo: state.scenario.memo,
            sortIndex: state.scenario.sortIndex === "" ? 0 : state.scenario.sortIndex,
            percentageTypeId: 2,
            currencyBucketId: state.scenario.tagetikCurrencyBucket,
            lastUpdateDate: (new Date()).toISOString(),
            nodes: state.scenario.nodes,
            isDeleted: state.scenario.isDeleted
        };

        if (state.scenario.scenarioId !== "") {
            ScenarioAPIService.update(newItem).then(
                data => {
                    const newItems = state.scenarios;
                    newItems[state.scenario.scenarioId] = data;
                    setState(values => ({ ...values, scenarios: newItem }));                                        
                    setAlertObject({ variant: 'success', alertMessage: 'Scenario updated' })
                    // refreshScenarioList();
                    var counter = 10
                    setInterval(function () {
                        counter--;
                        if (counter === 0) {
                            setShowAddEdit(false);
                            window.location.reload();
                        }
                    }, 200);
                }
            );            
        }
        else {
            newItem.nodeId = filterArray ? filterArray[1].value : 0;
            ScenarioAPIService.add(newItem).then(
                data => {
                    const newItems = state.scenarios;
                    newItems.push(data);
                    setState(values => ({ ...values, scenarios: newItems }));                                        
                    setAlertObject({ variant: 'success', alertMessage: 'Scenario Added' })
                   // refreshScenarioList();
                    var counter = 10
                    setInterval(function () {
                        counter--;
                        if (counter === 0) {
                            setShowAddEdit(false);
                            window.location.reload();
                        }
                    }, 200);
                }
            );            
        }       
    }

    return (
        <BasicCard cardConfig={{ cardTitle: 'Scenario details', cardHeadingElement: 'h4' }}>
            {alertObject.alertMessage ? <AlertMessage alertObject={alertObject} setAlertObject={setAlertObject} /> : ""}
            <ul>
                {state.scenario.nodeId !== "" ?
                    <li>
                        <span className='form-row'>
                            <label className='label'>Scenario code</label>
                            <input type='text' name="scenarioCode" value={state.scenario.scenarioCode} disabled onChange={handleChange} className='form-input'></input>
                        </span>
                    </li> : ""
                }
                <li>
                    <span className='form-row'>
                        <label className='label'>Scenario name</label>
                        <input type='text' name="scenarioName" value={state.scenario.scenarioName} onChange={handleChange} className='form-input'></input>
                    </span>
                </li>
                <li>
                    <span className='form-row'>
                        <label className='label'>Scenario type</label>
                        <label className='label'>Local</label>
                    </span>
                </li>
                <li>
                    <span className='form-row'>
                        <label className='label'>Mapping type</label>
                        <select disabled name="mappingTypeId" value={state.scenario.mappingTypeId} onChange={handleChange} className='form-select' >
                            {mappingTypes.map((mappingType) => {
                                return (
                                    <option key={mappingType.mappingTypeId} value={mappingType.mappingTypeId}>
                                        {mappingType.mappingTypeName}
                                    </option>
                                );
                            })}
                        </select>
                    </span>
                </li>
                <li>
                    <span className='form-row'>
                        <label className='label'>Percentage type</label>
                        <label className='label'>Flexible</label>
                    </span>
                </li>
                <li>
                    <span className='form-row'>
                        <label className='label-textarea'>Scenario memo</label>
                        <textarea name="memo" value={state.scenario.memo} onChange={handleChange} className='form-text-area' rows='4' cols='50'></textarea>
                    </span>
                </li>
                <li>
                    <span className='form-row'>
                        <label className='label'>Sort index</label>
                        <input type='number' name="sortIndex" value={state.scenario.sortIndex} onChange={handleChange} className='form-input'></input>
                    </span>
                </li>
                <li>
                    <span className='form-row'>
                        <label className='label'>Tagetik currency bucket</label>
                        <select name="tagetikCurrencyBucket" value={state.scenario.tagetikCurrencyBucket} onChange={handleChange} className='form-select' >
                            {currencies.map((currency) => {
                                return (
                                    <option key={currency.currencyBucketId} value={currency.currencyBucketId}>
                                        {currency.name}
                                    </option>
                                );
                            })}
                        </select>
                    </span>
                </li>                
                <li>
                    <span className='form-row'>
                        <label>Deleted</label>
                        <input type='checkbox' name='isDeleted' onChange={handleCheck} checked={state.scenario.isDeleted}></input>
                    </span>
                </li>
                {state.scenario.nodeId !== "" ?
                    <li>
                        <span className='form-row'>
                            <label className='label'>Last updated</label>
                            <p className='form-input-right'>{state.scenario.lastUpdateDate}</p>
                        </span>
                    </li> : ""
                }
                <span className='cancel-save'>
                    <a href='#' onClick={handleCancel}>Cancel</a>
                    <Button variant='primary' onClick={e => handleSave(e, state, setState, setShowAddEdit, 'nodeId')} className='ml-4'>Save</Button>
                </span>
            </ul>
            <Warning warningText='Are you sure you want to cancel?' handleConfirm={setCancelWarning} handleCancel={setShowAddEdit} show={cancelWarning} />
        </BasicCard>
    )
}
